import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class awards extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Event Info
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Awards
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    <section className="awards_section awards_page">
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Awards</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            {/* <p>Conference Organisation</p> */}
                                            <span className="position_relative yellow_color">OUR AWARDS</span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            {/* <div class="awrds_nav_btns">
             <div class="project__nav" data-aos="fade-left" data-aos-delay="200">
                  <button class="testimonial-button-prev"><i class="renova-left-arrow"></i></button>
                  <button class="testimonial-button-next"><i class="renova-right-arrow"></i></button>
              </div>
         </div> */}
                            <div className="row" data-aos="fade-up" data-aos-delay={500}>
                                <div className="col-md-12">
                                    <div className="swiper AwardSwiper1">
                                        <div className="swiper-wrapper">
                                            <div className="swiper-slide">
                                                <div className="award_grid">
                                                    <div>
                                                        <h4>
                                                            The Most Eminent Indian Exhibition by an Indian
                                                            Association - Catalysing India's Economic Growth
                                                        </h4>
                                                    </div>
                                                    <img
                                                        src="assets/img/awards/award_21.png"
                                                        alt="image"
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                            <div className="swiper-slide">
                                                <div className="award_grid">
                                                    <div>
                                                        <h4>
                                                            The Most Eminent Indian Exhibition by an Indian
                                                            Association - Catalysing India's Economic Growth
                                                        </h4>
                                                    </div>
                                                    <img
                                                        src="assets/img/awards/award_22.png"
                                                        alt="image"
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                            <div className="swiper-slide">
                                                <div className="award_grid">
                                                    <div>
                                                        <h4>
                                                            The Most Eminent Indian Exhibition by an Indian
                                                            Association - Catalysing India's Economic Growth
                                                        </h4>
                                                    </div>
                                                    <img
                                                        src="assets/img/awards/award_21.png"
                                                        alt="image"
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                            <div className="swiper-slide">
                                                <div className="award_grid">
                                                    <div>
                                                        <h4>
                                                            The Most Eminent Indian Exhibition by an Indian
                                                            Association - Catalysing India's Economic Growth
                                                        </h4>
                                                    </div>
                                                    <img
                                                        src="assets/img/awards/award_22.png"
                                                        alt="image"
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                            <div className="swiper-slide">
                                                <div className="award_grid">
                                                    <div>
                                                        <h4>
                                                            The Most Eminent Indian Exhibition by an Indian
                                                            Association - Catalysing India's Economic Growth
                                                        </h4>
                                                    </div>
                                                    <img
                                                        src="assets/img/awards/award_23.png"
                                                        alt="image"
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(awards));